import { Box, Menu } from "@mui/material";
import { CrossButton } from "../../../../../assets/common-svg/CommonSvg";
import { useFormik } from "formik";
import FormikControl from "../../../common/FormikControl";
import { LoadingButton } from "@mui/lab";
import { FormCommentList } from "../../../../../components/form-template/FormCommentList";
import { useDispatch, useSelector } from "react-redux";
import { queryChat, raisedQuery, rejectQuery, resolvedQuery, selectQueryLoading } from "../../../../slices/queryPreScreen";
import { hasAuthority } from "../../../../../utils/authorities";
import { notify } from "../../../../utils/methods/notification";
import { updateCartForm } from "../../../../slices/manufacturer";
import { validationSchemaCartComment } from ".";
import { selectCurrentCycle } from "../../../../slices/common"
import {getValueByPath} from "../../../../../utils/utils"
import { useMemo } from "react";
const decimalItems = ['moi','no_cell_transduced','mfg_cell','qc_cell','te_cell','car_t_dose_per_kg','total_car_t_cells_filled','total_t_cells_given_to_qc','total_t_cells_harvested','te_at_harvest','cd3_t_cells_in_leukapheresis','cd3_cells_taken_for_manufacturing','cd3_t_cells_after_md','cd3_t_cells_for_selection','cd3_t_cells_after_selection'];

const CarTComment = ({ initialSteps, handleMenuClose, anchorEl, open, queryData, selectedField, checkCarTForm, getPrimaryDiagnosis, formValues, handleManualFormikValidaction }) => {
    const dispatch = useDispatch()
    const LoginData = useSelector((state) => state.loginData);
    const role_slug = LoginData?.role_slug;
    // const userAuthority = LoginData?.auth || [];
    const isLoading = useSelector(selectQueryLoading)
    const currentCycle = useSelector(selectCurrentCycle)
    const initialValues = {
        comment: ""
    }
  const showButtons = useMemo(() => {
      return (
        initialSteps?.find((op) => op.slug === "product-manufactured")?.status == 2
      );
    }, [initialSteps]);

    const handleSubmit = async (values) => {
        const data = {
            prescreening_id: selectedField?.prescreening_id,
            patient_id: selectedField.patient_id,
            field_id: selectedField.field_id,
            data: {
                "is_file": selectedField?.is_file,
                "field_label": selectedField.field_label ?? selectedField?.field_name,
                "field_name": selectedField.field_name,
                "field_value": selectedField?.is_file ? selectedField.field_value : `${selectedField.field_value}`,
                "query": values.comment,
                "type": 3,
                "resolve_by": selectedField?.isResolve,
                "feasibility_assessment_id": currentCycle?.feasibility_assessments_id,
                "product_manufacturing_stage_id": currentCycle?.product_manufacturing_id,        
                "qr_code_generated_id": currentCycle?.qr_code_generation_id
            }
        }
        if (selectedField?.field_id && selectedField?.resolve == 0) {
            await dispatch(queryChat({ id: selectedField?.field_id, data: { query: values?.comment, resolve_by: selectedField?.isResolve,feasibility_assessment_id: currentCycle?.feasibility_assessments_id,
          product_manufacturing_stage_id: currentCycle?.product_manufacturing_id,        
          qr_code_generated_id: currentCycle?.qr_code_generation_id } }))
        } else {
            await dispatch(raisedQuery(data))
        }
        getPrimaryDiagnosis()
        handleMenuClose()
    }

    const updateForm = async (data) => {
        await dispatch(updateCartForm({ id: selectedField.prescreening_id, formData: data }))
    }
    

    const resolvedOurQuery = async () => {
         await formik.validateForm();
        if (!formik?.values?.comment?.trim() || !formik?.isValid) {
                return notify.error('Please add the comment')
            }
        let check = await handleManualFormikValidaction()

        if (check == 1) {
            try {
                
                let oldValue = getValueByPath(checkCarTForm, selectedField?.field_name);
                let newValue = getValueByPath(formValues, selectedField?.field_name);
                if (oldValue == newValue) {
                    notify.error("Please change the field's value first, then resolve query.")
                } else {
                    if(decimalItems?.includes(selectedField?.field_name)){
                      newValue = newValue.toFixed(2)
                    }
                    const {cell_count,...allValues } = formValues
                 const data = {
                    ...allValues,
                   ...cell_count?.length > 0 && {cell_count: JSON.stringify(cell_count)},
                }
                    await updateForm(data)
                    await dispatch(resolvedQuery({ id: selectedField.field_id, data: { new_value: newValue, is_file: selectedField?.is_file,resolve_by: selectedField?.isResolve,feasibility_assessment_id: currentCycle?.feasibility_assessments_id,
        product_manufacturing_stage_id: currentCycle?.product_manufacturing_id,        
        qr_code_generated_id: currentCycle?.qr_code_generation_id} }))
                    getPrimaryDiagnosis();
                }
            } catch (error) {
                console.error("Error in resolvedOurQuery:", error);
            }
        }
        handleMenuClose();
    }

    const rejectOurQuery = async () => {
       await dispatch(rejectQuery({id:selectedField.field_id,data:{resolve_by: selectedField?.isResolve,feasibility_assessment_id: currentCycle?.feasibility_assessments_id,
        product_manufacturing_stage_id: currentCycle?.product_manufacturing_id,        
        qr_code_generated_id: currentCycle?.qr_code_generation_id}}));
       getPrimaryDiagnosis()
        handleMenuClose()
    }

    const formik = useFormik({
        initialValues,
        validationSchema: validationSchemaCartComment,
        enableReinitialize: true,
        onSubmit: handleSubmit
    })

    const formOptions = {
        type: 'textarea',
        disabled: false,
        required: true,
        name: 'comment',
        placeholder: 'Enter Comment',
    }

    return <div>
        <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleMenuClose}
        >
            <Box className="p-2">
                <div className="flex flex-row-reverse border-b border-gray-300 pb-2">
                    <p className="flex gap-1 mr-3">
                        <span className="cursor-pointer" onClick={() => handleMenuClose()}>
                            <CrossButton />
                        </span>
                    </p>
                </div>
                <div className="p-3">
                    {queryData?.length != 0
                        ? <FormCommentList
                            loading={isLoading}
                            MenuData={queryData?.map(op => { return { name: `${op.raised_by[0]}${op.raised_by[1]}`, title: op.raised_by, describe: op.query, date: op.created_at, ...op } })}
                        />
                        : (
                          ''
                        )}
                </div>
                <form className="" onSubmit={formik.handleSubmit}>
                    <FormikControl formik={formik} {...formOptions} className="mt-2" />
                   {!showButtons && <div className="flex gap-2 mt-2">
                        {(hasAuthority(["manufacturing-approve"], LoginData?.bmr_permissions) || (!hasAuthority(["manufacturing-approve"], LoginData?.bmr_permissions) && selectedField?.id && selectedField?.resolve == 0)) && (
                            <LoadingButton
                                type="submit"
                                variant="contained"
                                fullWidth
                                disabled={isLoading}
                                className="disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                Submit
                            </LoadingButton>
                        )}

                      {selectedField?.isResolve?.includes(role_slug) &&
                        <LoadingButton
                            type="button"
                            disabled={isLoading || selectedField?.resolve != 0}
                            onClick={() => resolvedOurQuery()}
                            className="!bg-[#00B278] disabled:!bg-[#A0D9C7] disabled:cursor-not-allowed"
                            color="success"
                            variant="contained"
                            fullWidth
                        >
                            Resolve
                        </LoadingButton>}

                        <LoadingButton
                            type="button"
                            disabled={isLoading || selectedField?.resolve !== 0}
                            onClick={() => rejectOurQuery()}
                            className={`!border-[#FF2023] !text-[#FF2023] 
                                        ${isLoading || selectedField?.resolve !== 0
                                    ? '!border-[#FCA5A5] !text-[#FCA5A5] cursor-not-allowed opacity-50'
                                    : ''}`}
                            variant="outlined"
                            fullWidth
                        >
                            Reject
                        </LoadingButton>

                    </div>}
                </form>
            </Box>
        </Menu>
    </div>
}

export default CarTComment;